<template>
  <div class="row">
    <div class="col-12 col-md-7">

        <div class="row mb-4">
            <div class="col-12">
                <div class="s-lbl">Wie heißt Du?</div>
            </div>
            <div class="col-12">
                <input type="text" :class="{ 'invalid-input': inputErrors.name && validate }"  v-model="model.name" maxlength="10" required placeholder="z.B. Mario" />
            </div>
        </div>

        <div class="row">
          <div class="col-12  mb-4">
            <div class="s-lbl">Möchtest du ein Foto am Cover platzieren?
            </div>
          </div>

          <div class="col-12">
           <div class="s-nav height-5 upload-button"  >
              <div v-if="model.image === null">
                  <label for="files" class="btn btn-round no-hover text-center">BILD AUSWÄHLEN</label>
                  <input @change="onFileChange" id="files" style="visibility:hidden;width: 0;" type="file">
              </div>
               <div v-if="model.image !== null">
                   <a @click="removeImage()" class="btn btn-dark">BILD LÖSCHEN</a>
               </div>
           </div>

         </div>
         <div v-if="model.image !== null && !model.useil"  class="mb-5 img-crop">
             <vue-cropper
                 style="max-height: 300px"
                 ref="cropper"
                 :src="'/up/'+model.image"
                 :data="this.model.cropData"
                 alt="Source Image"
                 :autoCropArea="1"
                 :zoomable="false"
                 @crop="changeCrop(e)"
                 :aspectRatio="0.907692307692308"
                 :viewMode="1"
                 :minCropBoxWidth="68"
             >
             </vue-cropper>
         </div>
            <div class="col-12 form-check mb-4 grey">
                <input class="form-check-input check-black" checked type="checkbox" v-model="model.useil" name="useil" id="useil">
                <label class="form-check-label" for="illustration">
                    Illustration verwenden
                </label>
            </div>


        </div>
        <div class="d-flex nav-buttons">
            <div class="row mr-4">
                <div class="s-nav">

                </div>
            </div>
            <div class="row steps-wrapper">
                <div class="steps-info">
                    Schritt 1 von 3
                </div>
            </div>
            <div class="row">
                <div class="s-nav">
                    <router-link v-if="model.checked" to="Three">WEITER ></router-link>
                    <Popper @open:popper="openAlert"  v-if="!model.checked" content="Bitte fülle zuerst alle Felder aus">
                        <a class="btn btn-dark">WEITER ></a>
                    </Popper>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 col-md-5">
        <div class="cover-holder">
            <img src="/slides/child-slides/cover.jpg">
            <div class="cover-layer-text cover-name">
                <span v-html="model.name"></span>
            </div>

            <div v-if="model.canvas !== null && !model.useil" class="cover-layer-text cover-image">
                <img :src="model.canvas" />
            </div>

        </div>
    </div>
  </div>


</template>

<script>



import store from "@/store/store";

export default {

    name: 'step-two',
    components: {

    },
    data() {
        return {
            model: store.two,
            prevModel: store.one,
            nameSplitted: '',
            inputErrors: [],
            validate: false,
        }
    },
    watch: {
        'model.useil': function(val) {
            if(val) {
                this.removeImageItem();
            }
        },
        'model.name': function(val) {
          this.nameSplitted = val.replace(' ', '<br/>');
        },
        model: {
            deep: true,
            handler() {
                this.valid();
            }
        }
    },
    mounted() {
        let holidays = '[{"name":"Neujahr","date":"01.01.2024"},{"name":"Heilige Drei K\\u00f6nige","date":"06.01.2024"},{"name":"Ostermontag","date":"01.04.2024"},{"name":"Staatsfeiertag","date":"01.05.2024"},{"name":"Christi Himmelfahrt","date":"09.05.2024"},{"name":"Pfingstmontag","date":"20.05.2024"},{"name":"Fronleichnam","date":"30.05.2024"},{"name":"Mari\\u00e4 Himmelfahrt","date":"15.08.2024"},{"name":"Nationalfeiertag","date":"26.10.2024"},{"name":"Allerheiligen","date":"01.11.2024"},{"name":"Mari\\u00e4 Empf\\u00e4ngnis","date":"08.12.2024"},{"name":"Heiliger Abend","date":"24.12.2024"},{"name":"Christtag","date":"25.12.2024"},{"name":"Stefanitag","date":"26.12.2024"},{"name":"Silvester","date":"31.12.2024"}]';
        this.model.holidays = JSON.parse(holidays);


        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if(typeof params.name !== "undefined" && this.model.name.length === 0) {
            this.model.name = params.name;
        }

    },
    methods: {
        openAlert: function() {
            this.validate = true;
            this.valid();
        },

        valid: function() {
            this.inputErrors = [];
            let error = false;


            if(this.model.name.length === 0) {
                this.inputErrors['name'] = true;
                error = true;
            }

            console.log(this.model.useil);
            if(!this.model.useil && this.model.image === null) {
                console.log("test");
                error = true;
            }

            this.model.checked = error !== true;

        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isBirthday: function(evt) {

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                var v = this.input_value;
                if (v.match(/^\d{2}$/) !== null) {
                    this.input_value = v + '/';
                } else if (v.match(/^\d{2}\/\d{2}$/) !== null) {
                    this.input_value = v + '/';
                }
            }
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(files[0]);
        },
        createImage(file) {

            let formData = new FormData();

            formData.append("file", file);
            let vm = this;
            this.showLoading();
            fetch('/file/post', {method: "POST", body: formData}).then(async function (response) {
                const ret = await response.json();
                const uploaded_image = ret.path;
                vm.model.image = uploaded_image;
                vm.model.useil = false;
                vm.hideLoading();
            });


            //this.model.image = new Image();
            /*var reader = new FileReader();
            var vm = this;
            this.model.useil = false;
            reader.onload = (e) => {
                //console.log(e.target.result)
                vm.model.image = e.target.result;
            };
            reader.readAsDataURL(file);*/
        },
        removeImage: function () {
            this.removeImageItem();
            this.model.useil = true;
        },
        removeImageItem: function() {
            this.model.image = null;
            this.model.canvas = null;
        },
        changeCrop() {
            if(this.$refs.cropper !== null) {
                this.model.canvas = this.$refs.cropper.getCroppedCanvas().toDataURL();
                this.model.cropData = this.$refs.cropper.getData();
            }
        }

    }
}


</script>

<style scoped>

.cover-layer-text span {
    left: 140px;
    top: 256px;
    color: white;
    font-weight: bold;
    text-align: center;
    font-size: 15px;
    line-height: 18px;
    width: 90px;
}

.cover-firstname span {
    top: 294px;
    left: 138px;
}

.cover-image img {
    position: absolute;
    top: 124px;
    left: 46px;
    width: 61px;
    height: 65px;
    background: white;
    transform: rotate(-2deg);
}



.cover-birthdate span {
    top: 305px;
    left: 141px;
}

.cover-club span {
    top: 317px;
    left: 146px;
}

.cover-no span {
    top: 329px;
    left: 149px;

}

.cover-position span {
    top: 342px;
    left: 153px;

}

.cover-layer-text.cover-name span {
    top: 36px;
    left: 71px;
    color: black;
    text-align: left;
}
</style>
